// extracted by mini-css-extract-plugin
export var MsoFootnoteReference = "articleTitle-module--MsoFootnoteReference--a9008";
export var MsoFootnoteText = "articleTitle-module--MsoFootnoteText--58351";
export var articleDate = "articleTitle-module--articleDate--25761";
export var articleMeta = "articleTitle-module--articleMeta--bf41d";
export var articleTitle = "articleTitle-module--article-title--57539";
export var inlineGatsbyImageWrapper = "articleTitle-module--inline-gatsby-image-wrapper--0f0e4";
export var wpCaption = "articleTitle-module--wp-caption--d0024";